/**
 * Component Registry
 *
 * This registry allows child plugins to override components from the parent plugin.
 * It maintains a mapping of component names to their implementations.
 */

// Store component overrides

import * as components from "@parallelpublicworks/gatsby-clf/theme";

const componentRegistry = {};

export const registerComponent = (componentName, implementation, priority = 0) => {
	if (!componentRegistry[componentName]) {
		componentRegistry[componentName] = [];
	}
	componentRegistry[componentName][priority] = implementation;
};

export const getComponent = (componentName, defaultImplementation) => {
	if (componentRegistry[componentName]) {
		const highestPriority = Math.max(...Object.keys(componentRegistry[componentName]));
		return componentRegistry[componentName][highestPriority];
	}
	return defaultImplementation;
};

export const registerThemeComponents = () => {
	try {
		Object.entries(components).forEach(([name, Component]) => {
			if (name !== "theme") {
				registerComponent(name, Component);
			}
		});
	} catch (error) {
		console.error("Error registering theme components:", error);
	}
};
